// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8b3254f8","192":"ada6b5de","453":"d855a71b","608":"4f255232","689":"7848ad3b","962":"3d9d942e"}[chunkId] + ".chunk.js";
};